<template>
      <v-card height="100%">
        <v-card-title primary class="primary white--text">
          <h3 color="primary">ACTIONS</h3>
        </v-card-title>
        <v-list two-line>
          <v-btn outline :disabled="!isBuyerSelected" @click="openInvoice" class="primary--text font-weight-bold">
            <v-icon left>
              add
            </v-icon>
            <h3>New Invoice</h3>
          </v-btn>
          <v-spacer/>
        </v-list>
        <v-list two-line>    
          <router-link  style="text-decoration: none;" :to="{ name: 'InvoiceStatements', params: {customerId: selectedBuyer}}">
            <v-btn outline class="primary--text font-weight-bold">
              <v-icon left>
                visibility
              </v-icon>
            <h3> Statements </h3>
            </v-btn>
          </router-link>
        </v-list> 
        
        <v-list two-line>    
          <router-link v-if="isBuyerSelected" 
            style="text-decoration: none;"
            :to="{ 
              name: 'CustomerDeposit',
              params: {
                customerId: selectedBuyer
                }
              }">
              <v-btn outline class="primary--text font-weight-bold">
                <v-icon left>
                  account_balance_wallet
                </v-icon>
                <h3> Add Options </h3>
              </v-btn>
          </router-link>
        </v-list>

        <v-list two-line>    
          <router-link  style="text-decoration: none;" v-if="isBuyerSelected" 
            :to="{ 
              name: 'CustomerPayments',
              params: {
                customerId: selectedBuyer
                }
              }">
              <v-btn outline class="primary--text font-weight-bold" style="text-decoration: none;">
                <v-icon left>
                  receipt_long
                </v-icon>
                <h3> {{isBuyer ? 'New Receipt' : 'New Payment'}} </h3>
              </v-btn>
          </router-link>
        </v-list>
        
      </v-card>
    
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
//import Invoice from '../Invoice/'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

export default {
  components: {
   // Invoice
  },
  props: ['isBuyer'],
  data () {
    return {
      dialog: false,
      items: [],
      // invoices: [],
      firms:[],
      firmById: {},
      bankById: {},
      searchtext:''
    }
  },
  created () {
  },
  computed: {
    ...mapBuyerGetters(['selectedBuyer']),
    //...mapGlobalGetters(['selectedBrand','adminEmail','finYear']),
    isBuyerSelected () {
			if (this.selectedBuyer !== -1 && this.selectedBuyer !== "-1") {
				return true
			}
			return false
    },
  },
  methods: {
    openClosedTransactions() {
      this.$parent.$emit('buyer.statements.view');
    },
    getCurrentUserDetails(){
      let buyer = this.buyerById[this.selectedBuyer];
      let seller = this.sellerById[this.selectedBuyer];
      this.isBuyer = buyer && Object.keys(buyer).length != 0 ? true : false;
    },
    openInvoice (){
     this.$router.push({path: `/invoice-create/${this.selectedBuyer}/${this.isBuyer}` })
    }  
  },

  destroyed () {
    // this.$unbind('items')
    // this.$unbind('invoices')
  }
}
</script>

<style scoped>
  .avatar {
    background: #8d8d8d;
    color: white
  }
</style>



// WEBPACK FOOTER //
// src/components/Buyers/Buyer/BuyerItems.vue